import React, { Component, Fragment } from "react";
import Label from "../../../../components/atoms/Label";
import Button from "../../../../components/atoms/Button";
import LabelWithText from "../../../../components/molecules/LabelWithText";
import LabelWithInput from "../../../../components/molecules/LabelWithInput";
import curencyFormat from "../../../../utils/helpers/curencyFormat";
import TextBox from "../../../../components/atoms/TextBox";
import formatNumber from "../../../../utils/helpers/formatNumber";

export default ({ title, btnBottom, onChangeDataNegosiasi, dataNegosiasi, dataDetail, nextNego, statusNextNego, LoanGrade }) => {
	let col = { label: "col-md-3", text: "col-md-9" };
	let note = "Wajib diisi apabila Anda ingin melakukan negosiasi (*Nilai dalam %).";
	let filterLoanGrade = (grade) => {
		const value = LoanGrade.find(function (element) {
			return element.loanGrade === grade;
		});
		if (value) {
			return `(${value.minLoanRate}% - ${value.maxLoanRate}%)`;
		} else {
			return "";
		}
	};

	const sortDate = (date) => {
		if (date) {
			let sortDate = date.sort(function (a, b) {
				return new Date(b.createdAt) - new Date(a.createdAt);
			});
			//console.log('DISINI : ',{date, sortDate});

			return date;
		}
	};

	const checkStatusNego = () => {
		if (dataDetail.offeringHistory) {
			//console.log({ dataDetail  : dataDetail.offeringHistory, loanStatus : dataDetail.loanStatus});
			if (dataDetail.loanStatus === "AP0") {
				//console.log("gak masuk sini dong");

				if (sortDate(dataDetail.offeringHistory)[0].userType !== "BRW") {
					return true;
				} else {
					return false;
				}
			}
		}
	};

	const getPinjamanCair = () => {
		const { loanAmount, provisionFee, otherFee } = dataDetail;
		const pinjamanCair = loanAmount - provisionFee - otherFee;

		return pinjamanCair;
	};

	return (
		<div>
			<div className="container-title row">
				<Label value={title} className="label-menu" />
				{/*
					Menghapus fitur negosiasi pada proses setelah pinjaman disetujui oleh manager kkb-95
					checkStatusNego() &&
					(statusNextNego ? (
						<Button title={"Kembali"} onClick={() => nextNego(false)} type={"button"} color="blue" width="small outline" />
					) : (
						<Button title={"Negosiasi"} onClick={() => nextNego(true)} type={"button"} color="blue" width="small" />
					))
				*/}
			</div>
			{/*
				Menghapus fitur negosiasi pada proses setelah pinjaman disetujui oleh manager kkb-95
				dataDetail.loanStatus === "AP0" && !checkStatusNego() && (
				<Fragment>
					<i className="fas fa-exclamation-triangle icon_green"></i>
					<span className={"warning-text green"}>Menunggu aksi selanjutnya dari manajer</span>
				</Fragment>
			)*/}
			{dataDetail.loanStatus === "AC0" && (
				<Fragment>
					<i className="fas fa-exclamation-triangle icon_green"></i>
					<span className={"warning-text green"}>Menunggu aksi selanjutnya dari manajer untuk menerbitkan pinjaman</span>
				</Fragment>
			)}
			<div>
				<LabelWithText label={"Tipe Pinjaman"} text={dataDetail.loanTypeName || "-"} col={col} />
				<LabelWithText label={"Nilai Pinjaman"} text={`Rp ${dataDetail.loanAmount ? curencyFormat(dataDetail.loanAmount) : "-"}`} col={col} />
				<LabelWithText label={"Peringkat"} text={dataDetail.loanGrade ? `${dataDetail.loanGrade} ${filterLoanGrade(dataDetail.loanGrade)}` : "-"} col={col} />
				{checkStatusNego() && statusNextNego ? (
					<LabelWithInput label={"Suku Bunga Pinjaman"} note={note} col={col}>
						<TextBox name="sukuBunga" value={dataNegosiasi.loanRate} onChange={(val) => onChangeDataNegosiasi("loanRate", val.target.value)} />
					</LabelWithInput>
				) : (
					<LabelWithText label={"Suku Bunga Pinjaman"} text={`${formatNumber(dataDetail.loanRate, "", 2) || "- "}% p.a.`} col={col} />
				)}
				{checkStatusNego() && statusNextNego ? (
					<LabelWithInput label={"Persentase Biaya Layanan"} note={note} col={col}>
						<TextBox name="biayaLayanan" value={dataNegosiasi.provisionFeePercentage} onChange={(val) => onChangeDataNegosiasi("provisionFeePercentage", val.target.value)} />
					</LabelWithInput>
				) : (
					<LabelWithText label={"Persentase Biaya Layanan"} text={`${formatNumber(dataDetail.provisionFeePercentage, "", 2) || "- "}%`} col={col} />
				)}
				{checkStatusNego() && statusNextNego ? (
					<LabelWithText label={"Biaya Layanan"} text={`Rp ${dataNegosiasi.provisionFee ? curencyFormat(dataNegosiasi.provisionFee) : "-"}`} col={col} />
				) : (
					<LabelWithText label={"Biaya Layanan"} text={`Rp ${dataDetail.provisionFee ? curencyFormat(dataDetail.provisionFee) : "-"}`} col={col} />
				)}
				<LabelWithText label={"Biaya Transaksi"} text={`Rp ${dataDetail.otherFee ? curencyFormat(dataDetail.otherFee) : "-"}`} col={col} />
				<LabelWithText label={"Nilai Pinjaman Dicairkan"} text={`Rp ${curencyFormat(getPinjamanCair())}`} col={col} />
			</div>
			<div className="container-btn-ttd">
				{btnBottom &&
					btnBottom.map((value, index) => {
						let outline = value.outline && "outline";
						return <Button key={index} title={value.name} type={"button"} onClick={value.onClick} color={value.color} isDisabled={value.isDisabled} width={"big " + outline} className="padding-btn" />;
					})}
			</div>
		</div>
	);
};
